import { listKategori, listSubject } from "../../utils/aboutUtils";

export default function FormContact({ data, setData, submit }) {
  const onInput = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <form className=" w-full space-y-5 pb-16" onSubmit={(e) => submit(e, data)}>
      <input
        type="text"
        value={data.name}
        name="name"
        className="w-full rounded-lg border border-black px-3 py-1 font-nunito text-lg font-normal text-[#7F7F7F] focus:outline-none"
        placeholder="Nama Lengkap"
        onChange={(e) => onInput(e)}
      />
      <input
        type="text"
        value={data.email}
        name="email"
        className="w-full rounded-lg border border-black px-3 py-1 font-nunito text-lg font-normal text-[#7F7F7F] focus:outline-none"
        placeholder="Email"
        onChange={(e) => onInput(e)}
      />
      <select
        onChange={(e) => onInput(e)}
        className="w-full rounded-lg border border-black px-3 py-1 font-nunito text-lg font-normal capitalize text-[#7F7F7F] focus:outline-none"
        placeholder="Category"
        value={data.category}
        name="category"
      >
        {listKategori.map((item, i) => (
          <option
            key={i}
            value={item}
            hidden={i === 0 ? true : false}
            className="w-full rounded-lg border border-black px-3 py-2 font-nunito text-lg font-normal capitalize"
          >
            {item}
          </option>
        ))}
      </select>

      <select
        onChange={(e) => onInput(e)}
        className="w-full rounded-lg border border-black px-3 py-1 font-nunito text-lg font-normal capitalize text-[#7F7F7F] focus:outline-none"
        placeholder="Subject"
        value={data.subject}
        name="subject"
      >
        {listSubject.map((item, i) => (
          <option
            key={i}
            value={item}
            hidden={i === 0 ? true : false}
            className="w-full rounded-lg border border-black px-3 py-2 capitalize"
          >
            {item}
          </option>
        ))}
      </select>

      <textarea
        placeholder="Pesan"
        value={data.content}
        name="content"
        rows="4"
        cols="50"
        className="w-full rounded-lg border border-black p-3 font-nunito text-lg font-normal text-[#7F7F7F]"
        onChange={(e) => onInput(e)}
      />

      <button
        className="w-full rounded-lg bg-[#142D59] py-2 font-nunito text-xl font-bold text-white hover:opacity-80"
        type="submit"
      >
        Kirim
      </button>
    </form>
  );
}
